module.exports = new __parcel__URL__("promos_base2024_3_1_image.f42376b9.png").toString();